import React from 'react'
import { ArrowRightIcon } from 'components/design-system/kickoff-icons-v2/arrow-right-icon'
import s from './styles.module.css'
import { useSafeAreaInsets } from 'hooks/use-safe-area-insets'
import useMobileKeyboardOpen from 'hooks/use-mobile-keyboard-open'

interface NavigationControlsProps {
  onContinue?: () => void
  onSubmit?: () => void
  showContinue: boolean
  showSubmit: boolean
  isSubmitting?: boolean
  isContinueDisabled?: boolean
  shouldApplyKeyboardPadding?: boolean
}

const NavigationControls: React.FC<NavigationControlsProps> = ({
  onContinue,
  onSubmit,
  showContinue,
  showSubmit,
  isSubmitting = false,
  isContinueDisabled = false,
  shouldApplyKeyboardPadding = false,
}) => {
  const insets = useSafeAreaInsets()
  const { isKeyboardOpen, keyboardHeight } = useMobileKeyboardOpen(false)

  return (
    <div
      className={s.container}
      style={{
        // paddingBottom: Math.max(insets.bottom, 16),
        paddingBottom:
          shouldApplyKeyboardPadding && isKeyboardOpen
            ? Math.max(keyboardHeight || 0, 24)
            : Math.max(insets.bottom, 24),
      }}>
      {showSubmit && (
        <button
          type="button"
          onClick={onSubmit}
          className={s.submitButton}
          disabled={isSubmitting}
          aria-label="Submit survey">
          <span>
            {isSubmitting ? 'Finding your coach...' : 'Find Your Coach'}
          </span>
          <ArrowRightIcon />
        </button>
      )}
      {showContinue && (
        <button
          type="button"
          onClick={onContinue}
          className={s.continueButton}
          disabled={isSubmitting || isContinueDisabled}
          aria-label="Continue to next question">
          <span>Continue</span>
          <ArrowRightIcon />
        </button>
      )}
    </div>
  )
}

export default NavigationControls
